import { Button, FormControlLabel, Switch, Typography } from '@mui/material'
import { useFormikContext, Form } from 'formik'
import { useTranslation } from 'react-i18next'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { IUpdateAccountWelcomeShowForm } from 'src/types'

import { useStyles } from './styles'

export const ModalInner = () => {
  const [t] = useTranslation()
  const classes = useStyles()

  const { isSubmitting, dirty, values, errors, handleChange } =
    useFormikContext<IUpdateAccountWelcomeShowForm>()

  const buttonDis = isSubmitting || !dirty || !!Object.keys(errors).length

  return (
    <Form className={classes.form}>
      <Typography className={classes.formTitle}>
        <HelperWrapper t="welcome-account-modal-title" />
      </Typography>
      <div className={classes.formInner}>
        <FormControlLabel
          checked={values.show_welcome}
          onChange={handleChange}
          name="show_welcome"
          control={<Switch />}
          label={t('show-welcome-label.v')}
        />
        <Button type="submit" disabled={buttonDis}>
          <HelperWrapper t="update-button-text" />
        </Button>
      </div>
    </Form>
  )
}
